import React from "react";
import { FaInfo } from "react-icons/fa"; // Importer les icônes nécessaires

// ButtonEdit avec une icône d'information
const ButtonInfo = ({
  onClick,
  className = "",
  hoverLabel = "Informations",
}) => {
  return (
    <button
      onClick={onClick}
      aria-label={hoverLabel}
      title={hoverLabel}
      className={`w-8 h-8 bg-orange-500 text-white rounded-md shadow-sm transition duration-300 ease-in-out hover:bg-orange-700 flex items-center justify-center ${className}`}
    >
      <FaInfo className="text-[12px]" />
    </button>
  );
};

export default ButtonInfo;
